import { Table } from 'ypf-pas-general-ui-components';
import { CgClipboard } from 'react-icons/cg';
import { PropTypes } from 'prop-types';
import { useCallback, useContext, useEffect, useState } from 'react';

import { getUbicationDetails } from '../../../../services/certificationsMaster';
import useToast from '../../../../hooks/useToast';
import LoaderContext from '../../../../context/LoaderProvider';

import { getColumns } from './utils';

const SelectedQuantities = ({ idsPartesDiarios, isOpened }) => {
  const [ubicationDetails, setUbicationDetails] = useState({});
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const fetchUbicationData = useCallback(async () => {
    try {
      setLoader(true);
      const details = await getUbicationDetails(idsPartesDiarios);

      setUbicationDetails(details);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsPartesDiarios]);

  useEffect(() => {
    if (!isOpened) {
      return;
    }
    fetchUbicationData();
  }, [idsPartesDiarios, isOpened, fetchUbicationData]);

  return (
    <>
      <Table
        columns={getColumns()}
        data={ubicationDetails?.posicionesLineas ?? []}
        pageCount={20}
        size="sm"
        titleLeft
      />
      <div className="d-flex justify-content-end pt-4">
        <p className="h5" style={{ paddingRight: '70px' }}>
          <CgClipboard /> Monto pendiente a autorizar:
          <span style={{ fontWeight: 'bold' }}> ${ubicationDetails?.montoPendiente || 0}</span>
        </p>
      </div>
    </>
  );
};

export default SelectedQuantities;

SelectedQuantities.propTypes = {
  idsPartesDiarios: PropTypes.arrayOf(PropTypes.number).isRequired,
  isOpened: PropTypes.bool.isRequired
};
